export const DATE_WITH_SLASH_FORMAT = 'dd/MM/yyyy';
export const DATE_WITH_MONTH_WORD_FORMAT = 'dd LLL yy';
export const DATE_ISO_SHORT = 'yyyy-MM-dd';
export const API_LOCAL_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const API_TIME_FORMAT = 'HH:mm:ss';
export const SHORT_TIME_FORMAT = 'HH:mm';

export const scheduleTimezone = 'Europe/London';
